<app-search-query (enfant)="loadCollegesFromQuery()"></app-search-query>
<div class="card" *ngIf="progressBarValue">
  <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" [showValue]="true"></p-progressBar>
</div>
<div class="p-grid p-col-12">
  <div class="p-text-left">
    <br/>
    <span class="title-text-bold">{{collegesFromQuery?.length}} college(s)</span> -
    {{searchQueryComponent.selectedLocalite}}
  </div>
</div>
<p>Liste | Carte</p>
<div class="line-separator"></div>
<br/>
<div class="card">
  <p-dataView #dv [value]="collegesFromQuery" [paginator]="true" [rows]="2" filterBy="nom"
              [sortField]="sortField" [sortOrder]="sortOrder" layout="list">
    <ng-template pTemplate="header">
      <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
        <span class="p-input-icon-left p-mb-2 p-mb-md-0">
          <i class="pi pi-search"></i>
          <input name="search" type="search" pInputText placeholder="Recherche par nom"
                 (input)="dv.filter($event.target.value)">
        </span>
        <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
      </div>
    </ng-template>
    <ng-template let-college pTemplate="listItem">
      <div class="p-col-12">
        <br/>
        <div class="college-list-item">
          <div class="p-grid p-m-0">
            <div class="p-col-fixed div-cadre detail-search p-text-center" style="width:200px">
              Classement
            </div>
            <div class="p-col">
              <a routerLink="/detail-etablissement/{{college.id}}/college" routerLinkActive="active"
                 class="title-text-bold p-text-uppercase">
                {{college.nom}}
                <div class="grid-line-separator"></div>
              </a>
              <span class="p-tag p-m-1"> {{college.statut}}</span>
              <br/>
              <span class="p-m-1">
              <i class="pi pi-home"></i> {{college?.adresse?.district}}
               - {{college?.sousPrefecture?.nom}}
              </span>
              <br/>
              <span class="p-m-4">
                {{college?.sousPrefecture?.prefecture?.nom}}
              </span>
              <br/>
              <span class="p-m-4">
                {{college?.sousPrefecture?.prefecture?.regionAdministrative?.nom}}
              </span>
              <br/>
              <span class="p-m-1">
              <i class="pi pi-mobile"></i>
              Gsm: {{college?.adresse?.telephone}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template let-college pTemplate="gridItem">
      <div class="p-col-12 p-md-4">
        <div class="college-list-item">
          <div class="p-grid p-m-0">
            <div class="p-col-fixed div-cadre detail-search p-text-center" style="width:150px">
              Classement
            </div>
            <div class="p-col">
              <a routerLink="/detail-etablissement/{{college.id}}/college" routerLinkActive="active"
                 class="title-text-bold p-text-uppercase">
                {{college.nom}}
                <div class="grid-line-separator"></div>
              </a>
              <span class="p-tag p-m-1"> {{college.statut}}</span>
              <br/>
              <span class="p-m-1">
              <i class="pi pi-home"></i> {{college?.adresse?.district}}
               - {{college?.sousPrefecture?.nom}}
              </span>
              <br/>
              <span class="p-m-4">
                {{college?.sousPrefecture?.prefecture?.nom}}
              </span>
              <br/>
              <span class="p-m-4">
                {{college?.sousPrefecture?.prefecture?.regionAdministrative?.nom}}
              </span>
              <br/>
              <span class="p-m-1">
              <i class="pi pi-mobile"></i>
              Gsm: {{college?.adresse?.telephone}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-dataView>
</div>
